import { render, staticRenderFns } from "./AgentRenewalDetails.vue?vue&type=template&id=205136b4&scoped=true"
import script from "./AgentRenewalDetails.vue?vue&type=script&lang=js"
export * from "./AgentRenewalDetails.vue?vue&type=script&lang=js"
import style0 from "./AgentRenewalDetails.vue?vue&type=style&index=0&id=205136b4&prod&scoped=true&lang=css"
import style1 from "./AgentRenewalDetails.vue?vue&type=style&index=1&id=205136b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205136b4",
  null
  
)

export default component.exports